import { Logger } from './Logger'

export default function sdpTransform(_sdp: any, log?: Logger) {
    try {
        const sdp: string = _sdp as string
        //console.log('sdp before sdpTransform=%O', sdp)
        // Recall that sdpTransform gets called at every track change negotiation. We don't want to
        // replace a line that has already been replaced.
        let sdp_mod = sdp
            .split('\n')
            .map((line: string) => {
                if (line.indexOf('useinbandfec=1') < 0) {
                    return line
                }

                if (line.indexOf('stereo=1') < 0 && line.indexOf('sprop-stereo=1') < 0) {
                    return line.replace(
                        'useinbandfec=1',
                        'useinbandfec=1; stereo=1; sprop-stereo=1; maxaveragebitrate=192000'
                    )
                } else {
                    return line
                }
            })
            .join('\n')

        return sdp_mod
    } catch (e) {
        // @ts-ignore
        const msg = `Caught error at sdpTransform. message="${(e || {}).message}".`
        if (log) {
            log.error(`sdpTransform`, msg)
        } else {
            console.error(`sdpTransform: ` + msg)
        }
        return _sdp
    }
}

// https://webrtchacks.com/limit-webrtc-bandwidth-sdp/
// did not work.
function updateBandwidthRestriction(sdp: string, mediaType: 'audio' | 'video', bitrate: number) {
    const lines = sdp.split('\n')
    let line = -1
    for (let i = 0; i < lines.length; ++i) {
        if (lines[i].indexOf('m=' + mediaType) === 0) {
            line = i
            break
        }
    }
    if (line === -1) {
        return sdp
    }

    // Pass the m line
    line++

    // Skip i and c lines
    while (lines[line].indexOf('i=') === 0 || lines[line].indexOf('c=') === 0) {
        line++
    }

    // If we're on a b line, replace it
    if (lines[line].indexOf('b') === 0) {
        lines[line] = 'b=AS:' + bitrate
        return lines.join('\n')
    }

    // Add a new b line
    let newLines = lines.slice(0, line)
    newLines.push('b=AS:' + bitrate)
    newLines = newLines.concat(lines.slice(line, lines.length))
    return newLines.join('\n')
}
